import Image from 'next/image'
import type { Industry } from '@/types/exam'
import { cn } from '@/lib/utils'

const INDUSTRY_ART: Record<Industry, string> = {
  'Human Resources': '/illustrations/industry-hr.png',
  Nursing: '/illustrations/industry-nursing.png',
  'Project Management': '/illustrations/industry-pm.png',
  Medical: '/illustrations/industry-medical.png',
  'Speech-Language Pathology': '/illustrations/industry-slp.png',
  Counseling: '/illustrations/industry-counseling.png',
  'College Admissions': '/illustrations/industry-admissions.png',
}

interface IndustrySpotProps {
  industry: Industry
  /** Size override — defaults to h-8 w-8. */
  className?: string
}

/**
 * Industry marker used in the mega-panels, mobile accordions, and directory
 * headers — the flat-vector illustration spots (owner-picked; keep them).
 * Sized per surface via className instead of consumer-side img hacks.
 */
export function IndustrySpot({ industry, className }: IndustrySpotProps) {
  return (
    <Image
      src={INDUSTRY_ART[industry]}
      alt=""
      aria-hidden="true"
      width={256}
      height={256}
      sizes="32px"
      className={cn('shrink-0', className ?? 'h-8 w-8')}
    />
  )
}
